import PropTypes from 'prop-types';
import React from 'react';

import { DISPUTE_TYPE, RESOLVABLE_DISPUTE_STATUS } from '../../../config';

/** Resolvable dispute types. LATE_PAYMENT is not supported yet. */
const RESOLVABLE_TYPES = [DISPUTE_TYPE.OVERPAID, DISPUTE_TYPE.UNDERPAID];

/**
 * Per-row "Resolve" button. Enabled only while the dispute is open and of a
 * type we can resolve; opens the resolution modal via onResolve.
 */
const ResolveButton = ({ dispute, onResolve }) => {
  const canResolve =
    dispute?.status === RESOLVABLE_DISPUTE_STATUS &&
    RESOLVABLE_TYPES.includes(dispute?.dispute_type);

  const handleClick = (event) => {
    event.stopPropagation();
    if (canResolve) onResolve(dispute);
  };

  return (
    <button
      type="button"
      className="dispute-resolve-btn"
      data-testid="dispute-resolve-btn"
      onClick={handleClick}
      disabled={!canResolve}
    >
      Resolve
    </button>
  );
};

ResolveButton.propTypes = {
  dispute: PropTypes.object,
  onResolve: PropTypes.func.isRequired
};

export { ResolveButton };
